import { render, staticRenderFns } from "./history.vue?vue&type=template&id=87bf86d4"
import script from "./history.vue?vue&type=script&lang=ts"
export * from "./history.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports